const aboutConfig = [
	{
		title: null,
		data: [
			{
				key: 'Version:',
				value: '1.2.2',
				keySx: { mr: '4px', p: 2 },
				valueSx: { fontWeight: 'bold', p: 2 },
				valueType: 'text',
			},
			{
				key: 'Version Date:',
				value: 'June 7,2021',
				keySx: { mr: '4px', p: 2 },
				valueSx: { fontWeight: 'bold', p: 2 },
				valueType: 'text',
			},
			{
				key: 'Build No./Deployment:',
				value: '398',
				keySx: { mr: '4px', p: 2 },
				valueSx: { fontWeight: 'bold', p: 2 },
				valueType: 'text',
			},
		],
		style: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			borderBottom: 1,
			p: 4,
		},
	},
	{
		title: 'System specifications',
		data: [
			{
				key: 'Dario BGMS compatible App versions (Backend, iOS & Android):',
				value: '5.0.0 and up',
				keySx: { flex: 1, p: 2 },
				valueSx: { flex: 1.5, p: 2, fontWeight: 'bold' },
				valueType: 'text',
			},
			{
				key: 'Supported browsers:',
				value: 'Chrome, Safari, Microsoft Edge',
				keySx: { flex: 1, p: 2 },
				valueSx: { flex: 1.5, p: 2, fontWeight: 'bold' },
				valueType: 'text',
			},
			{
				key: 'Supported resolutions:',
				value: 'Desktop (recommended 1600*900), Tablet 10',
				keySx: { flex: 1, p: 2 },
				valueSx: { flex: 1.5, p: 2, fontWeight: 'bold' },
				valueType: 'text',
			},
		],
		style: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'space-between',
			borderBottom: 1,
			p: 4,
		},
	},
	{
		title: 'Help & Info',
		data: [
			{
				key: 'Customer support:',
				value: 'https://www.dariohealth.com/engage-support/',
				href: 'https://www.dariohealth.com/engage-support/',
				keySx: { flex: 1, p: 2 },
				valueSx: { flex: 1.5, p: 2, fontWeight: 'bold' },
				valueType: 'link',
			},
			{
				key: 'Email:',
				value: 'engage.support@dariohealth.com',
				href: 'mailTo:https://engage.support@dariohealth.com',
				keySx: { flex: 1, p: 2 },
				valueSx: { flex: 1.5, p: 2, fontWeight: 'bold' },
				valueType: 'link',
			},
			{
				key: 'Phone:',
				value: '1-888-408-4125',
				keySx: { flex: 1, p: 2 },
				valueSx: { flex: 1.5, p: 2, fontWeight: 'bold' },
				valueType: 'text',
			},
			{
				key: 'Terms of service:',
				value: 'https://www.dariohealth.com/contact/?_ga=2.101903109.588329916.1657253777-386446997.1657019569',
				href: 'https://www.dariohealth.com/contact/?_ga=2.101903109.588329916.1657253777-386446997.1657019569',
				keySx: { flex: 1, p: 2 },
				valueSx: { flex: 1.5, p: 2, fontWeight: 'bold' },
				valueType: 'link',
			},
			{
				key: 'Privacy policy:',
				value: 'http://mydario.com/privacy-policy/',
				href: 'http://mydario.com/privacy-policy/',
				keySx: { flex: 1, p: 2 },
				valueSx: { flex: 1.5, p: 2, fontWeight: 'bold' },
				valueType: 'link',
			},
		],
		style: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'space-between',
			p: 4,
		},
	},
]
export default aboutConfig
